<script setup>
import { ref, onMounted, watch, toRaw } from "vue";
import { storeToRefs } from "pinia";
import { easepick, RangePlugin } from "@easepick/bundle";
import { useFilteredFeedStore } from "../utils/store.js";

const store = useFilteredFeedStore();
const { filters } = storeToRefs(store);

const toggled = ref(false);

let picker;

onMounted(() => {
	initEasePick();
});

watch(filters, () => {
	const watchFilters = toRaw(filters.value);
	if (!Object.keys(watchFilters).length) {
		picker.clear();
	}
});

function doSearch() {
	toggled.value = false
	store.fetchItems()
}

function initEasePick() {
	const el = document.querySelector("#datepicker");
	if (!el) return;
	picker = new easepick.create({
		element: el,
		css: [
			"https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css",
			`${window.location.origin}/app/themes/z-arts2025/assets/dist/css/easepick.css`,
		],
		calendars: 2,
		grid: 2,
		zIndex: 10,
		inline: true,
		RangePlugin: {
			strict: false,
			tooltip: false,
		},
		plugins: [RangePlugin],
		setup(picker) {
			picker.on("select", (e) => {
				const { start, end } = e.detail;

				let q = {};
				if (start && end) {
					q.start_date = start.format("YYYY-MM-DD");
					q.end_date = end.format("YYYY-MM-DD");
					//   console.log(q);

					store.updateFilters({
						taxonomy: "start_date",
						term: q.start_date,
					});

					store.updateFilters({
						taxonomy: "end_date",
						term: q.end_date,
					});
				}
			});
		},
	});
}
</script>
<template>
	<div>
		<a
			href="#search-by-calender"
			class="font-bold hover:opacity-50 transition"
			data-modal="opener"
			arial-expanded="false"
			arial-haspopup="true"
			arial-label="opener modal opener"
			@click.prevent="toggled = !toggled"
			>
			<slot>Calendar</slot>
		</a>
		<div id="search-by-calender" class="modal bg-lilac z-40 overflow-y-auto overflow-x-hidden flex items-center justify-center" :class="{ '!visible !opacity-100': toggled }">
			
			<div class="relative">
				<h2 class="text-lg font-bold font-serif text-center flex justify-between items-center">

					<span>Search by date</span>

					<a
						href="#search-by-calender"
						class="w-6 md:w-8 hover:opacity-70 focus:opacity-70"
						data-modal="closer"
						arial-label="modal closer"
						@click.prevent="toggled = false"
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 40.828 40.828">
							<g id="Group_307" data-name="Group 307" transform="translate(-1410.586 -48.586)">
								<line
									id="Line_196"
									data-name="Line 196"
									x1="38"
									y1="38"
									transform="translate(1412 50)"
									fill="none"
									stroke="#fff"
									stroke-width="4"
								></line>
								<line
									id="Line_197"
									data-name="Line 197"
									y1="38"
									x2="38"
									transform="translate(1412 50)"
									fill="none"
									stroke="#fff"
									stroke-width="4"
								></line>
							</g></svg
					></a>

				</h2>
				<div class="max-w-[64.5rem] mx-auto text-center pt-10">
					<form action="#" class="flex flex-col gap-4 items-center">
						<label for="datepicker" class="mb-8">
							<span class="sr-only">Pick a date</span>
							<input id="datepicker" class="text-22 lg:h-14 opacity-0 invisible absolute" readonly="" />
							<span class="easepick-wrapper" style="position: relative; pointer-events: none"></span>
						</label>
						<button @click.prevent="doSearch()" class="btn bg-orange hover:bg-orange-tint text-black px-12">Search</button>
					</form>
					<div class="focusguard" tabindex="5"></div>
				</div>
				
			</div>
		</div>
	</div>
</template>
